/* tslint:disable */
/* eslint-disable */
export enum WorkBudgetSollSourceEnum {
  CalculatedSalary = 'calculated_salary'
}
